export default "__VITE_ASSET__hgj3bU8F__"